import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import moment from 'moment';
import axios from 'axios';
import VueTheMask from 'vue-the-mask';
import vuetify from './plugins/vuetify';
import i18n, { IDIOMA_PADRAO } from './i18n';
import { isDevHost } from './utils/env';
import { formatarMoeda, formatoLegado, simboloMoeda } from './utils/moeda';
import { deBrasiliaPara } from './utils/fuso';
import { isBrasil } from './utils/paises';
import 'moment/locale/pt-br';
import './registerServiceWorker';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.config.productionTip = false;

Vue.use(VueTheMask);
Vue.use(vuetify, {
    iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
});

Vue.mixin({
    methods: {
        notify(text, type = 'success') {
            setTimeout(() => this.$root.$emit('notify', {text, type}), 100);
        },

        formatPrice(value = 0, decimal = 2) {
            let val = (+value).toFixed(decimal).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },

        // Valor com a moeda da loja. `espaco` é o que a tela usava entre "R$" e o número (espaço comum,
        // espaço inseparável ou nada): em real/português o texto sai igual ao de antes.
        formatMoney(value = 0, espaco = ' ') {
            return formatoLegado() ? `R$${espaco}${this.formatPrice(value)}` : formatarMoeda(value);
        },

        // Os avisos antigos usavam toFixed (ponto decimal, sem milhar); em real/português continuam iguais.
        formatMoneyFixo(value = 0, espaco = '') {
            return formatoLegado() ? `R$${espaco}${(+value).toFixed(2)}` : formatarMoeda(value);
        },

        // Mensagem do pedido que colava o valor como veio (sem formatar); em real/português continua igual.
        formatMoneyCru(value = 0, espaco = '') {
            return formatoLegado() ? `R$${espaco}${value}` : formatarMoeda(String(value).replace(',', '.'));
        },

        simboloMoeda() {
            return simboloMoeda();
        },

        // Número sem moeda (percentual): em português o formatPrice de sempre; nos outros idiomas, o do idioma.
        formatNumero(value = 0, casas = 2) {
            return this.$i18n.locale === IDIOMA_PADRAO
                ? this.formatPrice(value, casas)
                : (+value || 0).toLocaleString(this.$i18n.locale, { minimumFractionDigits: casas, maximumFractionDigits: casas });
        },

        formatDate(dh, format = 'DD/MM/YYYY HH:mm') {
            return dh ? this.moment(dh).format(format) : '';
        },

        // Horário gravado em Brasília (updated_at, hora de cada status, itens da conta): fora do Brasil,
        // mostrado no fuso da loja. Loja do Brasil: o formatDate de sempre.
        formatInstante(dh, format = 'DD/MM/YYYY HH:mm') {
            const config = this.$store.state.configuracoes || {};

            // O mesmo que o formatDate do mixin, sem chamá-lo: um componente pode ter o seu.
            if (!dh || isBrasil(config.pais) || !config.timezone) {
                return dh ? this.moment(dh).format(format) : '';
            }

            return deBrasiliaPara(dh, config.timezone).format(format);
        },

        // Nome que o sistema grava em português (forma de entrega, forma de pagamento, dia da semana): em
        // português aparece como está no banco; nos outros idiomas, a tradução da chave, se houver.
        tSistema(chave, original) {
            return this.$i18n.locale === IDIOMA_PADRAO || !this.$te(chave) ? original : this.$t(chave);
        },
    },
});

// Em dev a API sobe no mesmo host que serve o cardápio (ver utils/env.js).
const host = window.location.hostname;
const baseURL = isDevHost(host)
    ? `http://${host}:8000/api`
    : 'https://webservice.zapermenu.com.br/api';

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.prototype.$http = axios.create({
    baseURL: baseURL + '/cardapio/'
});
Vue.prototype.$urlAPI = baseURL;

Vue.prototype.moment = moment;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
